// @flow
import * as React from 'react';
import { Box } from 'gestalt';

type Props = {|
  active?: boolean,
  borderRadius?: number,
  children?: any,
  focused?: boolean,
  hovered?: boolean,
  shape?: 'rounded' | 'pill' | 'circle',
  hoverBgColor?: ?('transparent' | 'lightGray' | 'white'),
  bgColor?: 'transparent' | 'lightGray' | 'white' | 'transparentDarkGray',
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl',
|};

// color(#efefef blackness(+ 6%))
const lightGrayHoverColor = 'rgb(226, 226, 226)';
// color(#efefef blackness(+ 10%))
const lightGrayActiveColor = 'rgb(218, 218, 218)';

export default function Pog(props: Props) {
  const {
    active = false,
    borderRadius,
    children,
    focused = false,
    hovered = false,
    shape,
    hoverBgColor,
    bgColor = 'transparent',
    size = 'lg',
  } = props;

  const activeStyles = active
    ? {
        backgroundColor: bgColor === 'transparent' ? 'rgba(0, 0, 0, 0.1)' : lightGrayActiveColor,
      }
    : null;

  const hoverBg =
    hovered && !focused && !active
      ? {
          backgroundColor:
            hoverBgColor ||
            (bgColor === 'transparent' ? 'rgba(0, 0, 0, 0.06)' : lightGrayHoverColor),
        }
      : null;

  const focusedStyles = focused
    ? {
        backgroundColor: bgColor === 'transparent' ? 'rgba(0, 0, 0, 0.06)' : lightGrayHoverColor,
        boxShadow: '0 0 0 4px rgba(0, 132, 255, 0.5)',
        outline: '0',
      }
    : null;

  const backgroundColors = {
    transparent: 'transparent',
    lightGray: '#efefef',
    white: '#fff',
    transparentDarkGray: 'rgba(51, 51, 51, 0.8)',
  };

  let height;
  if (shape === 'circle') {
    switch (size) {
      case 'xs':
        height = 24;
        break;
      case 'sm':
        height = 32;
        break;
      case 'md':
        height = 40;
        break;
      case 'lg':
        height = 48;
        break;
      case 'xl':
        height = 56;
        break;
      default:
        height = 48;
        break;
    }
  }
  const width = height;

  const inlineStyle = {
    backgroundColor: backgroundColors[bgColor],
    ...hoverBg,
    ...activeStyles,
    ...focusedStyles,
    ...(borderRadius ? { borderRadius } : {}),
  };

  return (
    <Box
      shape={shape}
      dangerouslySetInlineStyle={{ __style: inlineStyle }}
      height={height}
      width={width}
    >
      {children}
    </Box>
  );
}
